import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import 'bootstrap/dist/js/bootstrap.bundle'
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/scss/app.scss"
import "./assets/scss/orchit-design-system.scss"
import 'vue3-openlayers/dist/vue3-openlayers.css'
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import 'vue-rate/dist/vue-rate.css'
import "v3-tour/dist/vue-tour.css";
import '@globalhive/vuejs-tour/dist/style.css';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
import "vue-multiselect/dist/vue-multiselect.css"
import 'vue3-tour/dist/vue3-tour.css'
import '@fortawesome/fontawesome-free/css/all.css';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

import VueMultiselect from 'vue-multiselect'
import VueFeather from "vue-feather";
import { createI18n } from 'vue-i18n'
import Breadcrumbs from '@/layout/theBreadcrumbs.vue';
import OpenLayersMap from 'vue3-openlayers'
import Datepicker from '@vuepic/vue-datepicker';
import AosVue from "aos-vue";
import Lightbox from 'vue-easy-lightbox'
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import { VueMasonryPlugin } from 'vue-masonry';
import rate from 'vue-rate'
import VueTour from 'v3-tour'
import VueJsTour from '@globalhive/vuejs-tour';
import SimpleTypeahead from 'vue3-simple-typeahead';
import vueChartist from "vue-chartist"
import VueNumber from "vue-number-animation";
import { quillEditor } from "vue3-quill";
import Vue3Tour from 'vue3-tour'

import English from "@/locales/en.json" 
import لعربية from "@/locales/ae.json"
import 简体中文 from "@/locales/cn.json"
import Português from "@/locales/pt.json"
import Français from "@/locales/fr.json"
import Deutsch from "@/locales/de.json"
import Español from "@/locales/es.json"

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    messages: {
        English: English,
        Español: Español,
        Deutsch: Deutsch,
        Français: Français,
        Português: Português,
        简体中文: 简体中文,
        لعربية: لعربية,
    }
})

createApp(App)
    .use(router)
    .use(createPinia())
    .use(OpenLayersMap)
    .use(AosVue)
    .use(VueMasonryPlugin)
    .use(Lightbox)
    .use(rate)
    .use(VueTour)
    .use(VueNumber)
    .use(PerfectScrollbar)
    .use(VueJsTour)
    .use(SimpleTypeahead)
    .use(vueChartist)
    .use(quillEditor)
    .use(i18n)
    .use(Vue3Tour)
    .component(VueFeather.name || 'VueFeather', VueFeather)
    .component('Breadcrumbs', Breadcrumbs)
    .component('Datepicker', Datepicker)
    .component('multiselect', VueMultiselect)
    .component('FontAwesomeIcon', FontAwesomeIcon)
    .mount('#app')
